import { Select } from 'antd'
import React, { useEffect } from 'react'
import Loader from '../pages/pages/loader'
import { toast } from 'react-toastify'
import { useGetCustomersQuery } from '../redux/apis/customersManagement/customers/cMcustomerApiSlice'

const CustomersDropdown = ({ onChange, onBlur, value, className = "", isAll = false, disabled, mode= ""  }) => {
    const { data, isLoading, error } = useGetCustomersQuery({
        fields: ['id','customer_name'].join(','),
        page: '*',
    })
  

    let options

    if (data) {
        options = data?.data?.results?.map(x => {
            return { label: x.customer_name, value: x.id }
        })
        if (isAll) {
            options = [{ label: "All Customers", value: "10000" }, ...options]
        }

    }
    
	useEffect(() => {
        if (error?.data) {
          const errorMessages = Object.values(error.data).flat()
          errorMessages.forEach(message => {
            toast.error(message)
          })
        } 
      }, [error])

    return (
        <div className=" mb-3 flex-1">
            <label  className="form-label">customer</label>
            <br />
            <Select
                className={className}
                name='customer'
                showSearch
                style={{
                    width: "100%",
                }}
                optionFilterProp='label'
                defaultValue={value}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                loading={isLoading}
                options={options}
                disabled={disabled}
                mode={mode}
            />
        </div>
    )
}

export default CustomersDropdown